// extracted by mini-css-extract-plugin
export default {"container":"ComponentForLogoAndTitle_container__lMHm2","content":"ComponentForLogoAndTitle_content__7Q4Wi"};